/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { RegistrationLayout } from "../../components/RegistrationLayout";
import {
  allowedFileTypes,
  ButtonClickType,
  getProfileDescription,
  inputFieldMandatoryLabel,
  inputFieldOptionalLabel,
  OTHER,
  regexValidation,
  routeURL,
  UploadTypes,
} from "../../constants/commons";
import { UploadComp } from "../../molecules/Upload";
import {
  checkIfUploadIsPresentOfType,
  getErrorForField,
  getFieldConfigStatus,
  getImgURLFromBufferData,
  getSpecifObjTypeFromAPI,
  getStateCountryObject,
  isFieldOptional,
  letterCount,
  showDisplayHeadingAndContentFromLoadingStatus,
  useDataFromServerToDropdwon,
} from "../../utils/helpers";
import { basicInformationStyle } from "../BasicInformationPage/styles";
import { BasicProfileDetailsPageProps } from "./interfaces";
import { basicProfileDetailsStyle } from "./styles";
import { Input } from "antd";
import errorLogo from "../../assets/error-icon.svg";
import { RegistrationFooterButton } from "../../components/RegistrationFooterButton";
import { useIsMobile } from "../../hooks/useIsMobile";
import useSTR from "react-str";
import { deleteData, getData, postData } from "../../utils/fetchers";
import { URL } from "../../API/urlEndpoints";
import { toast } from "../../utils/toast";
import { useHistory } from "react-router-dom";
import { ShowMessage } from "../../components/ShowMessage";
import { useUserContext } from "../../hooks/cookieHooks";
import * as _ from "lodash";
import { ErrorComponent } from "../../molecules/ErrorComponent";
import {
  addressKeyTypes,
  FieldRenderState,
  Profession,
  RegisterationFields,
} from "../../commons/interfaces";
import { OptionField } from "@curefit/pandora";
import { ISelectOption } from "@curefit/pandora/dist/components/optionField/optionField.interfaces";
import { InputField } from "../../atoms/InputField";
import { responsiveStyles } from "../../commons/styles";

export const BasicProfileDetailsPage: React.FunctionComponent<BasicProfileDetailsPageProps> = (
  props
) => {
  const { TextArea } = Input;
  const {
    onBackButtonClick,
    onSaveAndExitClick,
    SuccessFullSaveObj,
    isProfilePictureUpdated,
  } = props;
  const history = useHistory();
  const isMobileView = useIsMobile();
  //State to maintain the uploaded docs/images
  const [successfullUploadedDocs, setSuccessfullUploadedDocs] = React.useState<
    any[]
  >([]);
  //State to maintain the profile Decsription
  const [profileDescription, setProfileDescription] = React.useState<string>();
  // State checking whether user can be navigated to the next page or not
  const [isNextPageNavAllowed, setIsNextPageNavAllowed] = React.useState<
    boolean
  >(false);
  // State for maintaining the city selected
  const [city, setCity] = React.useState<ISelectOption>();
  // State for maintaining the Clinic Name
  const [clinicName, setClinicName] = React.useState<string>();
  // State for maintaining the country selected
  const [country, setCountry] = React.useState<ISelectOption>();
  // State for maintaining the city selected
  const [selectedState, setSelectedState] = React.useState<ISelectOption>();
  // State for maintaining the ZIPCODE selected
  const [zipCode, setZipCode] = React.useState<string>();
  // State to maintain whether the PAN card is valid or not
  const [isEneteredZIPCodeValid, setIsEneteredZIPCodeValid] = React.useState<
    boolean
  >();
  // State to maintain whether the graduation degree is uploaded or not
  const [
    isProfilePictureUploaded,
    setIsProfilePictureUploaded,
  ] = React.useState<boolean>();
  // Calling the SSO Hook to retrieve user information of the logged in user
  const user = useUserContext();
  // State to maintain the custom entered CITY
  const [customCityEnetered, setCustomCityEnetered] = React.useState<string>();

  // [GET] On page load, for fetching details
  const [
    ,
    {
      result: getBasicProfileDetailsResult,
      revalidator: refetchBasicProfileDetailsResult,
      loading: loadingpBasicProfileDetailsResult,
      error: errorBasicProfileDetailsResult,
    },
  ] = useSTR(getData);

  // [POST] For Saving data on page.
  const [
    ,
    {
      result: postBasicProfileDetails,
      revalidator: refetchBasicProfileDetails,
      loading: loadingBasicProfileDetails,
      error: errorBasicProfileDetails,
    },
  ] = useSTR(postData);

  // [DELETE] For removing the uploaded Image
  const [
    ,
    {
      result: removeUploadedAsset,
      revalidator: refetchDeleteUploadedAsset,
      loading: loadingRemovedAsset,
      error: errorRemovedAsset,
    },
  ] = useSTR(deleteData);

  // [GET] On page load, for fetching country, state and city details for the DROPDOWN component
  const [
    ,
    {
      result: placeInfoData,
      revalidator: refetchPlaceInfoData,
      loading: loadingpPlaceInfoData,
      error: errorPlaceInfoData,
    },
  ] = useSTR(getData);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Hook which is called when an upload is successfully added/removed.
  // Updating the state here so that the submit button could be enabled/disabled based on the Profile Picture Upload
  React.useEffect(() => {
    setIsProfilePictureUploaded(
      checkIfUploadIsPresentOfType(
        UploadTypes.PROFILE_PICTURE,
        successfullUploadedDocs
      )[0]
    );
  }, [successfullUploadedDocs]);

  // On load, hitting the GET API
  React.useEffect(() => {
    refetchBasicProfileDetailsResult(
      `${URL.getPublicProfileDetails(_.get(user, "empId"))}`
    );
    // For fetching the country, state and city Dropdown values
    refetchPlaceInfoData(`${URL.getLocationDetails}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetching the GET API's result
  React.useEffect(() => {
    if (getBasicProfileDetailsResult) {
      const {
        profileDescription,
        profilePicture,
        address,
        clinicName,
      } = getBasicProfileDetailsResult;
      // clinicName
      clinicName && setClinicName(clinicName);
      // If address is already coming from server, show them in the respective fields
      if (address) {
        const { state, city, zipcode, country } = address;
        //State
        state && setSelectedState({ label: state, value: state });
        //City
        city && setCity({ label: city, value: city });
        // ZIPcode
        if (zipcode) {
          setZipCode(zipcode);
          setIsEneteredZIPCodeValid(true);
        }
        // Country
        country && setCountry({ label: country, value: country });
      }
      //If Profile pic is present
      // To get the selected Documents from the server on Page load
      let documentsFromServer = getImgURLFromBufferData([profilePicture]);
      documentsFromServer && setSuccessfullUploadedDocs(documentsFromServer);
      // Setting the state for Profile Description
      profileDescription && setProfileDescription(profileDescription);
    }
  }, [getBasicProfileDetailsResult]);

  // Showing the success message in a toast component / Fetching data From Server
  React.useEffect(() => {
    if (postBasicProfileDetails) {
      postBasicProfileDetails?.message &&
        toast.success(postBasicProfileDetails.message);
      if (isNextPageNavAllowed) {
        history.push(routeURL.finalAgreementPage);
      } else {
        SuccessFullSaveObj(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postBasicProfileDetails, isNextPageNavAllowed]);

  // Function called whenever the user successfully uploads an asset
  const onSuccessfullFileUpload = (onSuccessFileUploadObj: any) => {
    setSuccessfullUploadedDocs([onSuccessFileUploadObj]);
    isProfilePictureUpdated && isProfilePictureUpdated(true);
  };

  // Function which is called when the Profile Decsreiption is changed
  const onProfileDescriptionChange = (
    profileDescriptionChange: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setProfileDescription(profileDescriptionChange.target.value);
  };

  // For showing/hiding the Profile Picture Upload Component
  const showProfileUploadComponent = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicProfileDetailsResult.fieldsconfig,
        RegisterationFields.PROFILE_PICTURE
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicProfileDetailsResult]);

  // For showing/hiding the CLINIC ADDRESS
  const showClinicAddressField = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicProfileDetailsResult.fieldsconfig,
        RegisterationFields.CLINIC_ADDRESS
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicProfileDetailsResult]);

  // Function which lets us know whether the user has enetred something in the CITY input field
  const showUserEneteredCityTextBox = React.useMemo(() => {
    return city && city?.label?.includes(OTHER);
  }, [city]);

  // For showing the label OPTIONAL for CLINIC_ADDRESS
  const showClinicAddressOptionalField = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicProfileDetailsResult.fieldsconfig,
          RegisterationFields.CLINIC_ADDRESS
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicProfileDetailsResult]);

  // Function which allows the user to go to the next screen
  const isSubmitAllowed = React.useMemo(() => {
    return !(
      successfullUploadedDocs &&
      profileDescription &&
      !(showClinicAddressField
        ? false
        : showClinicAddressOptionalField
        ? true
        : isEneteredZIPCodeValid) &&
      !(showClinicAddressField
        ? false
        : showClinicAddressOptionalField
        ? true
        : showUserEneteredCityTextBox
        ? customCityEnetered
        : city?.value) &&
      !(showClinicAddressField
        ? false
        : showClinicAddressOptionalField
        ? true
        : selectedState) &&
      !(showClinicAddressField
        ? false
        : showClinicAddressOptionalField
        ? true
        : country) &&
      !(showClinicAddressField
        ? false
        : showClinicAddressOptionalField
        ? true
        : clinicName) &&
      !(showClinicAddressField
        ? false
        : showClinicAddressOptionalField
        ? true
        : zipCode) &&
      (showProfileUploadComponent ? isProfilePictureUploaded : true)
    );
  }, [
    showClinicAddressField,
    successfullUploadedDocs,
    profileDescription,
    isEneteredZIPCodeValid,
    city,
    customCityEnetered,
    showUserEneteredCityTextBox,
    showClinicAddressOptionalField,
    showProfileUploadComponent,
    isProfilePictureUploaded,
    selectedState,
    country,
    clinicName,
    zipCode,
  ]);

  // Callback from the parent Component to SAVE AND QUIT
  React.useEffect(() => {
    onSaveAndExitClick && onPositiveActionClick(ButtonClickType.SAVE_AND_EXIT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSaveAndExitClick]);

  // Function which constructs the necessary JSON as per the API call
  const constructDataForPOSTAPI = React.useCallback(() => {
    let bankAccountDetailsObj = {
      profilePicture: {
        isUploaded: true,
        fileExtension:
          successfullUploadedDocs &&
          Object.keys(successfullUploadedDocs).length > 0 &&
          successfullUploadedDocs[0].fileName,
        filename: UploadTypes.PROFILE_PICTURE,
      },
      ...{ clinicName },
      address: {
        city:
          city && showUserEneteredCityTextBox
            ? customCityEnetered
            : city?.value,
        state: selectedState && selectedState.value,
        country: country && country.value,
        zipcode: zipCode as string,
      },
      profileDescription,
    };
    return bankAccountDetailsObj;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    successfullUploadedDocs,
    profileDescription,
    showUserEneteredCityTextBox,
    customCityEnetered,
    city,
    country,
    selectedState,
    zipCode,
    clinicName,
  ]);

  // Function which decides whether the control should be re-directed to the next sreen or just SAVE
  const onPositiveActionClick = (buttonClickType: ButtonClickType) => {
    const basicProfileDetailsObj = constructDataForPOSTAPI();
    // POST CALL
    switch (buttonClickType) {
      case ButtonClickType.NEXT:
        let paramsObj = {
          ...basicProfileDetailsObj,
          customHeader: { change_state: true },
        };
        refetchBasicProfileDetails(
          `${URL.postPublicProfileDetails(_.get(user, "empId"))}`,
          paramsObj
        );
        setIsNextPageNavAllowed(true);
        break;

      case ButtonClickType.SAVE_AND_EXIT:
        refetchBasicProfileDetails(
          `${URL.postPublicProfileDetails(_.get(user, "empId"))}`,
          basicProfileDetailsObj
        );
        setIsNextPageNavAllowed(false);
        break;

      default:
        break;
    }
  };

  // Function which is called when the ProfilePicture is removed
  const removeSelectedAsset = (removedAsset: any) => {
    const { filename, id } = removedAsset;
    refetchDeleteUploadedAsset(
      `${URL.removeUploadedAsset(_.get(user, "empId"), id, filename)}`
    );
    // Filtering and removing the DELETED Asset from the ASSET's Collection
    setSuccessfullUploadedDocs(
      successfullUploadedDocs.filter(
        (uploadedDocs) => uploadedDocs !== removedAsset
      )
    );
  };

  // Function which is executed after successfully removing the uploaded Asset
  React.useEffect(() => {
    if (removeUploadedAsset && removeUploadedAsset.success) {
      toast.success(removeUploadedAsset.message);
      isProfilePictureUpdated && isProfilePictureUpdated(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeUploadedAsset]);

  // Variable which shows the loading state
  const isScreenLoading = React.useMemo(() => {
    return (
      loadingpBasicProfileDetailsResult ||
      loadingBasicProfileDetails ||
      loadingRemovedAsset ||
      loadingpPlaceInfoData
    );
  }, [
    loadingpBasicProfileDetailsResult,
    loadingBasicProfileDetails,
    loadingRemovedAsset,
    loadingpPlaceInfoData,
  ]);

  // Hook which is called whenever there is an error in either GET/POST calls
  const showErrorComponent = React.useMemo(() => {
    return (
      errorRemovedAsset ||
      errorBasicProfileDetails ||
      errorBasicProfileDetailsResult ||
      errorPlaceInfoData
    );
  }, [
    errorBasicProfileDetailsResult,
    errorBasicProfileDetails,
    errorRemovedAsset,
    errorPlaceInfoData,
  ]);

  // For showing the label OPTIONAL for Profile Picture Upload Component
  const showProfileUploadLabel = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicProfileDetailsResult.fieldsconfig,
          RegisterationFields.PROFILE_PICTURE
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicProfileDetailsResult]);

  // For showing/hiding the Profile Picture Description Component
  const showProfileDescriptionComponent = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicProfileDetailsResult.fieldsconfig,
        RegisterationFields.PROFILE_DESC
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicProfileDetailsResult]);

  // For showing the label OPTIONAL for Profile Picture Upload Component
  const showProfileDescriptionLabel = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicProfileDetailsResult.fieldsconfig,
          RegisterationFields.PROFILE_DESC
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicProfileDetailsResult]);

  // For showing/hiding the CITY
  const showCityField = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicProfileDetailsResult.fieldsconfig,
        RegisterationFields.CLINIC_CITY
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicProfileDetailsResult]);

  // For showing the label OPTIONAL for CITY
  const showCityLabel = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicProfileDetailsResult.fieldsconfig,
          RegisterationFields.CLINIC_CITY
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicProfileDetailsResult]);

  // For showing/hiding the STATE
  const showStateField = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicProfileDetailsResult.fieldsconfig,
        RegisterationFields.CLINIC_STATE
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicProfileDetailsResult]);

  // For showing the label OPTIONAL for STATE
  const showStateLabel = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicProfileDetailsResult.fieldsconfig,
          RegisterationFields.CLINIC_STATE
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicProfileDetailsResult]);

  // For showing/hiding the COUNTRY
  const showCountryField = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicProfileDetailsResult.fieldsconfig,
        RegisterationFields.CLINIC_COUNTRY
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicProfileDetailsResult]);

  // For showing the label OPTIONAL for STATE
  const showCountryLabel = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicProfileDetailsResult.fieldsconfig,
          RegisterationFields.CLINIC_COUNTRY
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicProfileDetailsResult]);

  // For showing/hiding the CLINIC_NAME
  const showClinicNameField = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicProfileDetailsResult.fieldsconfig,
        RegisterationFields.CLINIC_NAME
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicProfileDetailsResult]);

  // For showing the label OPTIONAL for CLINIC_NAME
  const showClinicNameLabel = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicProfileDetailsResult.fieldsconfig,
          RegisterationFields.CLINIC_NAME
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicProfileDetailsResult]);

  // For showing errors [CITY]
  const cityError = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.errors &&
      getErrorForField(
        RegisterationFields.CLINIC_CITY,
        getBasicProfileDetailsResult.errors
      )
    );
  }, [getBasicProfileDetailsResult]);

  // For showing errors [STATE]
  const stateError = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.errors &&
      getErrorForField(
        RegisterationFields.CLINIC_STATE,
        getBasicProfileDetailsResult.errors
      )
    );
  }, [getBasicProfileDetailsResult]);

  // For showing errors [COUNTRY]
  const countryError = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.errors &&
      getErrorForField(
        RegisterationFields.CLINIC_COUNTRY,
        getBasicProfileDetailsResult.errors
      )
    );
  }, [getBasicProfileDetailsResult]);

  // Getting hold of City Dropdown values
  const citiesDropdwonValues = useDataFromServerToDropdwon(
    getSpecifObjTypeFromAPI(placeInfoData, addressKeyTypes.CITY) || undefined
  );

  // Getting hold of State Dropdown values
  const stateDropdwonValues = useDataFromServerToDropdwon(
    getSpecifObjTypeFromAPI(placeInfoData, addressKeyTypes.STATE) || undefined
  );

  // For changing the CITY
  const onCityChange = (option: ISelectOption) => {
    setSelectedState({
      label: getStateCountryObject(option.value, placeInfoData).state,
      value: getStateCountryObject(option.value, placeInfoData).state,
    });
    setCountry({
      label: getStateCountryObject(option.value, placeInfoData).country,
      value: getStateCountryObject(option.value, placeInfoData).country,
    });
    setCity(option);
  };

  // For changing the State
  const onStateChange = (option: ISelectOption) => {
    setSelectedState(option);
  };

  // For changing the COUNTRY
  const onCountryChange = (option: ISelectOption) => {
    setCountry(option);
  };

  // For changing the ZIP Code
  const onZipCodeChange = (zipCode: string) => {
    if (zipCode && zipCode.length > 7) {
      return;
    } else {
      setZipCode(zipCode);
    }
  };

  // Hook which is called when the ZIP code enetred is right or wrong
  const isZipCodeEneteredValid = (isZipCodeValid: boolean) => {
    setIsEneteredZIPCodeValid(isZipCodeValid);
  };

  // For changing the clinic name
  const onclinicNameChange = (enteredClinicName: string) => {
    setClinicName(enteredClinicName);
  };

  // For showing errors [ZIPCODE]
  const zipCodeError = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.errors &&
      getErrorForField(
        RegisterationFields.CLINIC_ZIP_CODE,
        getBasicProfileDetailsResult.errors
      )
    );
  }, [getBasicProfileDetailsResult]);

  // Getting hold of Country Dropdown values
  const countryDropdwonValues = useDataFromServerToDropdwon(
    getSpecifObjTypeFromAPI(placeInfoData, addressKeyTypes.COUNTRY) || undefined
  );

  // For showing/hiding the ZIPCODE
  const showZipCodeField = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicProfileDetailsResult.fieldsconfig,
        RegisterationFields.CLINIC_ZIP_CODE
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicProfileDetailsResult]);

  // For showing the label OPTIONAL for ZIPCODE
  const showZipCodeLabel = React.useMemo(() => {
    return (
      getBasicProfileDetailsResult &&
      getBasicProfileDetailsResult.fieldsconfig &&
      _.keys(getBasicProfileDetailsResult.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicProfileDetailsResult.fieldsconfig,
          RegisterationFields.CLINIC_ZIP_CODE
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicProfileDetailsResult]);

  // Getting hold of the changed CITY name - Manual Entry
  const onCustomCityEneteredChange = (enteredCity: string) => {
    setCustomCityEnetered(enteredCity);
  };

  return (
    <span
      css={[responsiveStyles, basicInformationStyle, basicProfileDetailsStyle]}
    >
      <ShowMessage
        visible={isScreenLoading}
        loading={isScreenLoading}
        heading={
          showDisplayHeadingAndContentFromLoadingStatus({
            preLoginScreen: loadingpBasicProfileDetailsResult,
            postLoginScreen: loadingBasicProfileDetails || loadingRemovedAsset,
          })?.loadingHeading
        }
        description={
          showDisplayHeadingAndContentFromLoadingStatus({
            preLoginScreen: loadingpBasicProfileDetailsResult,
            postLoginScreen: loadingBasicProfileDetails || loadingRemovedAsset,
          })?.loadingDescription
        }
      />
      <RegistrationLayout>
        <h2>Public Profile Details</h2>
        {showProfileUploadComponent && (
          <div
            className={`mb-2 ${
              isMobileView ? "col-12 p-0" : "d-flex align-items-center"
            }`}
          >
            <div className="d-flex flex-column">
              <div className="d-flex">
                <h6 className="">Profile Picture</h6>
                <div className="small-text ml-2">
                  {showProfileUploadLabel ? (
                    showProfileUploadLabel
                  ) : (
                    <div className="responsive-error-asterix-style">
                      {inputFieldMandatoryLabel}
                    </div>
                  )}
                </div>
              </div>
              <div className="short-description-style ">
                White background recommended
              </div>
            </div>

            <div className="ml-auto ">
              <div className="col-12 d-flex align-items-center justify-content-center p-0">
                <UploadComp
                  onSuccess={onSuccessfullFileUpload}
                  uploadType={UploadTypes.PROFILE_PICTURE}
                  uploadedFiles={successfullUploadedDocs}
                  removeSelectedAsset={removeSelectedAsset}
                  allowedFilesType={[
                    allowedFileTypes.jpeg,
                    allowedFileTypes.jpg,
                    allowedFileTypes.png,
                  ]}
                  allowedFileSize={10}
                />
              </div>
            </div>
          </div>
        )}
        {showProfileDescriptionComponent && (
          <div>
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                <h6>Profile Description</h6>
                <div className="small-text ml-2">
                  {showProfileDescriptionLabel ? (
                    showProfileDescriptionLabel
                  ) : (
                    <div className="responsive-error-asterix-style">
                      {inputFieldMandatoryLabel}
                    </div>
                  )}
                </div>
              </div>
              <div>
                {profileDescription
                  ? letterCount(profileDescription)
                  : "0 / 300"}
              </div>
            </div>

            <div className="mt-2 mb-3 d-flex">
              <TextArea
                value={profileDescription}
                rows={10}
                cols={10}
                defaultValue={profileDescription}
                allowClear
                maxLength={300}
                onChange={onProfileDescriptionChange}
                placeholder="Write profile description here"
              />
            </div>
            <div className={` ${isMobileView ? "mt-3 mb-5" : "my-3"}`}>
              <div className="profile-decsription-container p-3">
                <div className="my-2 d-flex align-items-center">
                  <img
                    src={errorLogo}
                    alt=""
                    className="logo-responsive-styling"
                  />
                  <div className="ml-2 display-content-style">
                    Public details can be edited anytime in future
                  </div>
                </div>
                <div className="py-3">
                  <h6>Profile description example</h6>
                  <div className="decsription-message-style">
                    Top tips for writing a good profile description:
                    <br /> - Keep it sweet, short, simple and professional
                    <br /> - Talk about your experience, education,
                    certification and other skills that can be relevant to your
                    customers
                    <br /> - If you have a speciality, don't hesitate to talk
                    about it
                    <br />
                    {!!getProfileDescription(
                      user.memberships[0].context as Profession
                    ) &&
                      getProfileDescription(
                        user.memberships[0].context as Profession
                      )}
                  </div>
                </div>
              </div>
            </div>
            {showClinicAddressField && (
              <div className="mt-3">
                <div className="d-flex">
                  <h6>Clinic Address</h6>

                  <span className="small-text ml-2">
                    {showClinicAddressOptionalField ? (
                      showClinicAddressOptionalField
                    ) : (
                      <div className="responsive-error-asterix-style">
                        {inputFieldMandatoryLabel}
                      </div>
                    )}
                  </span>
                </div>

                {showClinicNameField && (
                  <InputField
                    placeholder={`Clinic Name ${
                      showClinicNameLabel
                        ? inputFieldOptionalLabel
                        : inputFieldMandatoryLabel
                    }`}
                    type="text"
                    className="pt-3"
                    initialValue={clinicName}
                    onChange={onclinicNameChange}
                  />
                )}
                {showZipCodeField && (
                  <InputField
                    placeholder={`Zip Code ${
                      showZipCodeLabel
                        ? inputFieldOptionalLabel
                        : inputFieldMandatoryLabel
                    }`}
                    type="number"
                    className="pt-3"
                    initialValue={zipCode}
                    onChange={onZipCodeChange}
                    validationRegEx={regexValidation.zipCode}
                    validationErrMsg={`${
                      zipCodeError
                        ? zipCodeError
                        : "Please enter a valid ZIP code"
                    }`}
                    validate={isZipCodeEneteredValid}
                  />
                )}
                <div className="row p-0">
                  {showCityField && (
                    <div
                      className={`col-xs-12 my-3 ${
                        showUserEneteredCityTextBox
                          ? "col-md-6 d-flex align-items-center"
                          : "col-md-12"
                      }`}
                    >
                      <OptionField
                        options={citiesDropdwonValues}
                        value={city}
                        placeholder={`Enter your city ${
                          showCityLabel
                            ? inputFieldOptionalLabel
                            : inputFieldMandatoryLabel
                        }`}
                        onChange={(option: ISelectOption) =>
                          onCityChange(option)
                        }
                      />
                      {cityError && (
                        <div className="error-text">{cityError}</div>
                      )}
                    </div>
                  )}
                  {showUserEneteredCityTextBox && (
                    <div className="col-md-6">
                      <InputField
                        placeholder={`Please enter city name ${
                          showCityLabel
                            ? inputFieldOptionalLabel
                            : inputFieldMandatoryLabel
                        }`}
                        type="text"
                        className="my-3"
                        onChange={onCustomCityEneteredChange}
                      />
                      {cityError && (
                        <div className="error-text">{cityError}</div>
                      )}
                    </div>
                  )}
                  {showStateField && (
                    <div
                      className={`col-xs-12 col-md-6 ${
                        isMobileView ? "my-3" : ""
                      }`}
                    >
                      <OptionField
                        options={stateDropdwonValues}
                        value={selectedState}
                        placeholder={`Enter your state ${
                          showStateLabel
                            ? inputFieldOptionalLabel
                            : inputFieldMandatoryLabel
                        }`}
                        onChange={(option: ISelectOption) =>
                          onStateChange(option)
                        }
                      />
                      {stateError && (
                        <div className="error-text">{stateError}</div>
                      )}
                    </div>
                  )}
                  {showCountryField && (
                    <div
                      className={`col-xs-12 col-md-6 ${
                        isMobileView ? "my-3" : ""
                      }`}
                    >
                      <OptionField
                        options={countryDropdwonValues}
                        value={country}
                        placeholder={`Select your country ${
                          showCountryLabel
                            ? inputFieldOptionalLabel
                            : inputFieldMandatoryLabel
                        }`}
                        onChange={(option: ISelectOption) =>
                          onCountryChange(option)
                        }
                      />
                      {countryError && (
                        <div className="error-text">{countryError}</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        {showErrorComponent && <ErrorComponent errorObj={showErrorComponent} />}
      </RegistrationLayout>
      <RegistrationFooterButton
        disableNextButton={isSubmitAllowed}
        onPositiveActionClick={onPositiveActionClick}
        onBackButtonClick={onBackButtonClick}
      />
    </span>
  );
};
